import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgNespressoMachine32 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 29,
  height: 28,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.167 0c.736 0 1.333.597 1.333 1.333V28h-12V8H8.16l-.66 2h-1l-.67-2H.5V1.333C.5.597 1.097 0 1.833 0h25.334ZM14.5 27v1H.5v-1h14ZM27.167 1H1.833a.333.333 0 0 0-.326.266l-.007.067L1.499 7H17.5l-.001 20h10L27.5 1.333a.333.333 0 0 0-.266-.326L27.167 1ZM12.5 16v4c0 2.945-2 6-5 6s-5-3-5-6v-4h10Zm-1.001 1h-8l.001 3c0 2.632 1.681 4.869 3.811 4.994L7.5 25c2.14 0 3.897-2.194 3.996-4.772L11.5 20l-.001-3Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgNespressoMachine32;